import React from 'react';

// Types
import { MetricSlugs } from '../../ManagerDashboardData.constants';

// Components
import MetricsWrapper from '../MetricsWrapper';
import BarChart from 'Shared/components/charts/BarChart';

// Styles
import './CumulativeActions.scss';

type Props = {
  teamActivity;
};

const CumulativeActions = ({ teamActivity }: Props) => {
  const baseClassName = 'CumulativeActions';

  return (
    <MetricsWrapper slug={MetricSlugs.cumulative_actions}>
      <div className={`${baseClassName}__chart`}>
        <BarChart
          datasets={teamActivity.chart.datasets}
          labels={teamActivity.chart.labels}
          options={teamActivity.chart.options}
        />
      </div>
    </MetricsWrapper>
  );
};

export default CumulativeActions;
